var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dd4343;}.cls-2{fill:#231f20;}.cls-3{fill:#beddf4;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Cloud Failed",
    id: "Cloud_Failed"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 48.21,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,61.21a13,13,0,1,1,13-13A13,13,0,0,1,32,61.21Zm0-24a11,11,0,1,0,11,11A11,11,0,0,0,32,37.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,52.63a1,1,0,0,1-.71-1.71l8-8a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41l-8,8A1,1,0,0,1,28,52.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,52.63a1,1,0,0,1-.71-.3l-8-8a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l8,8A1,1,0,0,1,36,52.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,21.55c0-7.37-6.26-13.34-14-13.34s-14,6-14,13.34a14.31,14.31,0,0,0-9.9,3.9A13.13,13.13,0,0,0,4.32,32,12.55,12.55,0,0,0,4,34.88,13.89,13.89,0,0,0,16,48.21h1c0-8.5,6.79-15.5,15-15.5s15,7,15,15.5h1a14.39,14.39,0,0,0,7.91-3.9,13.44,13.44,0,0,0,3.77-6.58A12.77,12.77,0,0,0,60,34.88C60,27.51,53.74,21.55,46,21.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48,49.22a1,1,0,0,1-.15-2A13.47,13.47,0,0,0,55.2,43.6,11.85,11.85,0,0,0,59,34.88c0-6.8-5.83-12.33-13-12.33a1,1,0,0,1-1-1c0-6.8-5.83-12.34-13-12.34S19,14.75,19,21.55a1,1,0,0,1-1,1,13.28,13.28,0,0,0-9.21,3.62,12.19,12.19,0,0,0-3.5,6.08A12.54,12.54,0,0,0,5,34.88,12.88,12.88,0,0,0,16.14,47.22a1,1,0,1,1-.28,2,15.17,15.17,0,0,1-8.57-4.28A15.33,15.33,0,0,1,3,34.89a13.52,13.52,0,0,1,.34-3.08,14.15,14.15,0,0,1,4.07-7.09A15.14,15.14,0,0,1,17,20.58c.53-7.46,7-13.37,15-13.37s14.44,5.91,15,13.37c7.82.47,14,6.71,14,14.3A13.89,13.89,0,0,1,56.61,45a15.52,15.52,0,0,1-8.46,4.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.1df9290a5b67e06c963f11224ac50053.svg";
export { ForwardRef as ReactComponent };